module.exports = __webpack_public_path__ + "static/bg_image-14f2eeb7230bd690f082e4fd50baf4a3.jpg";